import {Action} from "@ngrx/store";

export const LOAD_HOSTING_VISITS: string = '[hosting block] Load Hosting Visits';
export const LOAD_HOSTING_VISITS_SUCCESS: string = '[hosting block] Load Visits Success';
export const LOAD_HOSTING_VISITS_FAIL: string = '[hosting block] Load Visits Fail';

export const LOAD_HOSTING_VISITS_BY_WEBSITE: string = '[hosting block by website] Load Hosting Visits by Website';
export const LOAD_HOSTING_VISITS_BY_WEBSITE_SUCCESS: string = '[hosting block by website] Load Visits Success by Website';
export const LOAD_HOSTING_VISITS_BY_WEBSITE_FAIL: string = '[hosting block by website] Load Visits Fail by Website';

export const LOAD_HOSTING_VISITS_BY_WEBSITE_BY_DATE: string = '[hosting block by website by date] Load Hosting Visits by Website by Date';
export const LOAD_HOSTING_VISITS_BY_WEBSITE_BY_DATE_SUCCESS: string = '[hosting block by website by date] Load Visits Success by Website by Date';
export const LOAD_HOSTING_VISITS_BY_WEBSITE_BY_DATE_FAIL: string = '[hosting block by website by date] Load Visits Fail by Website by Date';

export class LoadHostingVisits implements Action {

  readonly type: string = LOAD_HOSTING_VISITS;
  constructor(public payload?: number) {}

}

export class LoadHostingVisitsSuccess implements Action {

  readonly type: string = LOAD_HOSTING_VISITS_SUCCESS;
  constructor(public payload: {}) {}

}

export class LoadHostingVisitsFail implements Action {

  readonly type: string = LOAD_HOSTING_VISITS_FAIL;
  constructor(public payload: string) {}

}


export class LoadHostingVisitsByWebsite implements Action {
  readonly type: string = LOAD_HOSTING_VISITS_BY_WEBSITE;
  constructor(public payload: number) {}
}

export class LoadHostingVisitsByWebsiteSuccess implements Action {

  readonly type: string = LOAD_HOSTING_VISITS_BY_WEBSITE_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    entities: any,
  }) {}

}

export class LoadHostingVisitsByWebsiteFail implements Action {

  readonly type: string = LOAD_HOSTING_VISITS_BY_WEBSITE_FAIL;
  constructor(public payload: string) {}

}

export class LoadHostingVisitsByWebsiteByDate implements Action {
  readonly type: string = LOAD_HOSTING_VISITS_BY_WEBSITE_BY_DATE;
  constructor(public payload: {websiteId: number, date: any}) {}
}

export class LoadHostingVisitsByWebsiteByDateSuccess implements Action {

  readonly type: string = LOAD_HOSTING_VISITS_BY_WEBSITE_BY_DATE_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    entities: any,
  }) {}

}

export class LoadHostingVisitsByWebsiteByDateFail implements Action {

  readonly type: string = LOAD_HOSTING_VISITS_BY_WEBSITE_BY_DATE_FAIL;
  constructor(public payload: string) {}

}

export type HostingVisitsAction = LoadHostingVisits | LoadHostingVisitsSuccess | LoadHostingVisitsFail | LoadHostingVisitsByWebsite | LoadHostingVisitsByWebsiteSuccess | LoadHostingVisitsByWebsiteFail | LoadHostingVisitsByWebsiteByDate | LoadHostingVisitsByWebsiteByDateSuccess | LoadHostingVisitsByWebsiteByDateFail;
